<template>
    <div
        class="relative flex items-start justify-between bg-gray-300 px-4 py-4 text-xs border border-l-0 border-white"
    >
        <div class="flex-1">
            <div class="text-xxs text-gray-900">
                <span class="hidden md:inline-block text-gray-700">Entry Time:</span> {{ annotation.updated_at_formatted }}
            </div>

            <div class="text-sm lg:text-base font-bold text-gray-900">
                <a :href="'/users/' + annotation.report_user_id + '/reportsections/' + annotation.report_section_id" target="_blank" class="no-underline">{{ annotation.report_section_name }}</a>
            </div>
        </div>

        <div class="flex-none">
            <a :href="'/users/' + annotation.report_user_id + '/reportsections/' + annotation.report_section_id" target="_blank"><i aria-hidden="true" class="material-icons previeweye text-indigo-500 hover:text-indigo-700">remove_red_eye</i></a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        annotation: null,
    },
}
</script>
